import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const COLORS = ['#9754e3', '#fff'];

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{
                background: 'rgba(20, 20, 20, 0.95)',
                border: '1px solid rgba(151, 84, 227, 0.4)',
                borderRadius: '8px',
                padding: '10px 14px',
                backdropFilter: 'blur(10px)'
            }}>
                <p className='fl cw fs12' style={{ marginBottom: 4 }}>{payload[0].name}</p>
                <p className='fb cw'>{payload[0].value.toFixed(1)}%</p>
            </div>
        );
    }
    return null;
};

const renderCustomLabel = ({ cx, cy, midAngle, outerRadius, value, name }) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius + 25;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="rgba(255,255,255,0.8)" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize={11} fontFamily="m">
            {name} ({value.toFixed(1)}%)
        </text>
    );
};

const ReChartRadial = ({ data, label }) => {
    return (
        <div className='df fdc'>
            <p className='fb cs fs12 mb1' style={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}>{label}</p>
            {data?.length > 0 && (
                <div style={{ width: '100%', height: '200px' }} className='df aic jcc'>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                dataKey="value"
                                cx="50%"
                                cy="50%"
                                innerRadius={50}
                                outerRadius={70}
                                paddingAngle={4}
                                strokeWidth={0}
                                label={renderCustomLabel}
                            >
                                {data.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={entry.fill || COLORS[index % COLORS.length]}
                                        style={{ filter: 'drop-shadow(0 0 6px rgba(151, 84, 227, 0.3))' }}
                                    />
                                ))}
                            </Pie>
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    );
};

export default ReChartRadial;
